import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudTank = () => import('./staff/crudTank')
const ViewStaffCrudSensorsAssociateTankCustomer = () => import('./staff/crudSensorsAssociateTankCustomer')
const ViewStaffListSensorsTankCustomer = () => import('./staff/listSensorsTankCustomer')
const ViewStaffDetailSensorsTankCustomer = () => import('./staff/detailSensorsTankCustomer')
const ViewStaffCrudSensorsNotifications = () => import('./staff/crudSensorsNotifications')
const ViewStaffConfigurations = () => import('./staff/configurations')

const ViewCustomersDashboard = () => import('./customer/dashboard')
const ViewCustomerListSensorsTank = () => import('./customer/listSensorsTankCustomer')
const ViewCustomerDdetailSensorsTank = () => import('./customer/detailSensorsTank')
const ViewCustomerCrudSensorsNotifications = () => import('./customer/crudSensorsNotifications')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SensorsStaffDashboard',
  crudTank: 'SensorsStaffCrudTank',
  listSensorsTankCustomer: 'SensorsStaffListSensorsTankCustomer',
  crudSensorsAssociateTankCustomer: 'SensorsStaffCrudSensorsAssociateTankCustomer',
  detailSensorsTankCustomer: 'SensorsStaffDetailSensorsTankCustomer',
  crudSensorsNotifications: 'SensorsStaffNotificationsSensorsTankCustomer',
  configurations: 'SensorsStaffConfigurations',
}

const router =
  [
    {
      path: '/st/sensors',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sensores',
          }                                 
        },
        {
          path: 'tanks',
          name: VIEWS.crudTank,
          component: ViewStaffCrudTank,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de tanques',
          }                                 
        },              
        {
          path: 'tanks/customer',
          name: VIEWS.listSensorsTankCustomer,
          component: ViewStaffListSensorsTankCustomer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Tanques de cliente',
          }                                 
        },
        {
          path: 'tanks/associate/customer',
          name: VIEWS.crudSensorsAssociateTankCustomer,
          component: ViewStaffCrudSensorsAssociateTankCustomer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Asignación de tanque',
          }                                 
        },                     
        {
          path: 'tanks/customer/:customerTankID/detail',
          name: VIEWS.detailSensorsTankCustomer,
          component: ViewStaffDetailSensorsTankCustomer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Detalle de tanque',
          }                                 
        },            
        {
          path: 'tanks/customer/:customerTankID/notifications',
          name: VIEWS.crudSensorsNotifications,
          component: ViewStaffCrudSensorsNotifications,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Notificaicones de sensores',
          }                                 
        },        
        {
          path: 'configurations',
          name: VIEWS.configurations,
          component: ViewStaffConfigurations,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuración de sensores',
          }                                 
        },                                  
      ]
    },

    {
      path: '/cu/sensors',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'SensorsCustomerDashboard',
          component: ViewCustomersDashboard,
          beforeEnter: Permisos.IS_CLIENTE,
          meta: {
            title: 'Sensores',
          }                                 
        },
        {
          path: 'tanks/customer',
          name: 'SensorsCustomerListSensorsTank',
          component: ViewCustomerListSensorsTank,
          beforeEnter: Permisos.IS_CLIENTE,
          meta: {
            title: 'Mis Tanques',
          }                                 
        },        
        {
          path: 'tanks/customer/:customerTankID/detail',
          name: 'SensorsCustomerDetailSensorsTank',
          component: ViewCustomerDdetailSensorsTank,
          beforeEnter: Permisos.IS_CLIENTE,
          meta: {
            title: 'Detalle de tanque',
          }                                 
        },            
        {
          path: 'tanks/customer/:customerTankID/notifications',
          name: 'SensorsCustomerNotificationsSensorsTank',
          component: ViewCustomerCrudSensorsNotifications,
          beforeEnter: Permisos.IS_CLIENTE,
          meta: {
            title: 'Notificaciones de sensores',
          }                                 
        },
      ]
    },

    {
      path: '/su/sensors',
      component: DefaultContainer,
      children: [
      
      ]
    },    
  ]

export default router
export { VIEWS }
